import { getPropsForClickTracking } from "../../utils/tracking";
$ const { mapMessage } = input;

<ebay-section-notice class="map-message" a11y-text="information" status="information" a11y-role-description="Notice">
  <@footer>
    <ebay-fake-link
      title=(mapMessage.callToAction?.text)
      data-testid="map-message-link"
      on-click("onCtaClick")
      ...getPropsForClickTracking(mapMessage.callToAction?.action?.trackingList)
    >
      ${mapMessage.callToAction?.text}
    </ebay-fake-link>
  </@footer>
  <fe-textual-display data-testid="map-message-text" model=(mapMessage.message?.additionalText?.[0])/>
</ebay-section-notice>
